if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"_vk_cloud_solar_extensions_lk_host","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^([29]64|178|297|400|909)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}